import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {AllInterceptor} from './all-interceptor';

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AllInterceptor, multi: true}
];
